import {
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {Stock} from "../../../shared/view-model/stock";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {SessionActions} from "../../../shared/actions/session.actions";
import {WithdrawalService} from "../../services/withdrawal.service";
import {isNullOrUndefined} from "util";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {WithdrawalDataFormComponent} from "../../withdrawal/withdrawal-data-form/withdrawal-data-form.component";
import {MissionService} from "../../../mission/services/mission.service";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {WarehousingDataFormComponent} from "../../warehousing/warehousing-data-form/warehousing-data-form.component";
import {WarehousingService} from "../../services/warehousing-service/warehousing.service";
import {mergeMap} from "rxjs/operators";

@Component({
  selector: 'vb-actual-stock',
  templateUrl: './actual-stock.component.html',
  styleUrls: ['./actual-stock.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ActualStockComponent)}],
  entryComponents: [GenericModalComponent]
})
export class ActualStockComponent extends AbstractVisbosControl<Stock, FormControl> implements OnInit {

  @Input()
  styleClass: string;

  @Input()
  autofocus: boolean = false;

  @Output()
  actualStockChanged: EventEmitter<number> = new EventEmitter();

  @Output()
  stockChangeCanceled: EventEmitter<any> = new EventEmitter();

  @ViewChild('input')
  input: ElementRef;

  @ViewChild('wdTmpl')
  wdTmpl: TemplateRef<any>;
  @ViewChild('wdDataForm')
  wdDataForm: WithdrawalDataFormComponent;
  withdrawalForm: FormGroup;
  stockWithdrawalInput: { stock: Stock, amount: number };

  @ViewChild('warehousingTmpl')
  warehousingTmpl: TemplateRef<any>;
  @ViewChild('warehousingDataForm')
  warehousingDataForm: WarehousingDataFormComponent;
  warehousingForm: FormGroup;
  stockIncreaseInput: { stock: Stock, amount: number };

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private appRef: ApplicationRef, private componentFactoryResolver: ComponentFactoryResolver,
              private wdService: WithdrawalService, private missionService: MissionService, private warehousingService: WarehousingService) {
    super(fb, cd, sessionActions);
  }

  buildControlContent(): FormControl {
    return this.fb.control(null);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.autofocus) {
      let nEl: HTMLElement = this.input.nativeElement;
      setTimeout(() => {
        nEl.focus();
      }, 0);
    }
    this.cd.markForCheck();
  }

  public setDefaultValues(item?: Stock): { [controlKey: string]: any } | any {
    return this.setValue(item, 'act_stock');
  }

  onStockChange() {

    if (!this.item || isNullOrUndefined(this.item.act_stock)) {
      this.actualStockChanged.emit(this.control.value); // TODO: Change to mutation result!?
      return;
    }

    let newActStock = this.control.value;
    let actStock = this.item.act_stock;
    let diff = newActStock - actStock;

    if (newActStock == actStock) {
      console.info("No change in the actual stock");
    }
    if (newActStock < actStock) {
      this.onStockDecrease(diff * -1);
    }
    if (newActStock > this.item.act_stock) {
      this.onStockIncrease(diff);
    }

  }

  onBlur() {
    // Don't cancel change on blur since the input blurs when one of the modals opens
    //    this.cancelStockChange();
  }

  cancelStockChange() {
    console.info("Canceled stock change");
    //this.reset();
    this.stockChangeCanceled.emit();
    this.cd.detectChanges();
  }

  onStockDecrease(amount: number) {
    this.withdrawalForm = WithdrawalDataFormComponent.initControl(this.fb);
    this.stockWithdrawalInput = {stock: this.item, amount: amount};
    this.showWithdrawalModal();
    this.cd.markForCheck();
  }

  onStockIncrease(amount: number) {
    this.warehousingForm = WarehousingDataFormComponent.initControl(this.fb);
    this.stockIncreaseInput = {stock: this.item, amount: amount};
    this.showWarehousingModal();
    this.cd.markForCheck();
  }

  setClasses() {
    let actStock = this.control.value;
    let cssClasses = {
      'bg-warning': actStock > this.item.min_stock && this.item.act_stock <= this.item.report_stock,
      'bg-danger': actStock <= this.item.min_stock,
      'bg-success': actStock > this.item.report_stock,
    };
    return cssClasses;
  }

  showWithdrawalModal() {
    let modal = this.createModal(this.appRef, this.componentFactoryResolver, this.wdTmpl, GenericModalComponent).instance;

    modal.modalTitle = "Angaben zum Artikelausgang";
    modal.successLabel = "Entnahme abschließen";
    modal.cancelLabel = "Entnahme abbrechen";
    modal.okEnabled = this.withdrawalForm.valid;

    this.dataSubscriptions.push(this.withdrawalForm.statusChanges.subscribe(stat => {
      modal.okEnabled = this.withdrawalForm.valid;
    }));

    this.dataSubscriptions.push(modal.okClicked.subscribe(() => {
      let val = this.withdrawalForm.value;
      let query;

      if (val.missionData) {
        query = this.missionService.createMission(val.missionData)
          .pipe(mergeMap(res => {
              val.withdrawal['withdrawal_reason_id'] = res.cuid;
              return this.wdService.createWithdrawal(val.withdrawal, val.medicineWithdrawalData);
            })
          );
      } else {
        query = this.wdService.createWithdrawal(val.withdrawal, val.medicineWithdrawalData);
      }

      query.toPromise()
        .then(res => {
          this.sessionActions.pushMessage("Entnahme erfolgreich gespeichert!", MessageType.SUCCESS, "Artikelentnahme");
        }).catch(err => {
        this.sessionActions.pushMessage("Fehler bei der Artikelentnahme!", MessageType.ERROR, "Artikelentnahme");
      });

      let newActStock = this.control.value;
      this.actualStockChanged.emit(newActStock); // TODO: Change to mutation result!?
      this.cd.detectChanges();

    }));

    this.dataSubscriptions.push(modal.cancelClicked.subscribe(() => {
      this.cancelStockChange();
    }));

    modal.show();
  }


  showWarehousingModal() {
    let modal = this.createModal(this.appRef, this.componentFactoryResolver, this.warehousingTmpl, GenericModalComponent).instance;

    modal.modalTitle = "Angaben zum Artikeleingang";
    modal.successLabel = "Einlagerung abschließen";
    modal.cancelLabel = "Einlagerung abbrechen";
    modal.okEnabled = this.warehousingForm.valid;

    this.dataSubscriptions.push(this.warehousingForm.statusChanges.subscribe(stat => {
      modal.okEnabled = this.warehousingForm.valid;
    }));

    this.dataSubscriptions.push(modal.okClicked.subscribe(() => {
      let val = this.warehousingForm.value;
      let query;

      query = this.warehousingService.createWarehousing(val.warehousing, val.medicineAuthData);

      query.toPromise()
        .then(res => {
          this.sessionActions.pushMessage("Einlagerung erfolgreich gespeichert!", MessageType.SUCCESS, "Artikeleingang");
        }).catch(err => {
        this.sessionActions.pushMessage("Fehler bei der Artikeleinlagerung!", MessageType.ERROR, "Artikeleingang");
      });

      let newActStock = this.control.value;
      this.actualStockChanged.emit(newActStock); // TODO: Change to mutation result!?
      this.cd.markForCheck();

    }));

    this.dataSubscriptions.push(modal.cancelClicked.subscribe(() => {
      this.cancelStockChange();
    }));

    modal.show();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/actual-stock/actual-stock.component.ts